<div>

  <div class="top">
    <div class="floatR">
      <button *ngIf="hasPermission('manage_users')" nz-button nzType="primary" nzShape="circle" (click)="addUser()">
        <span nz-icon nzType="plus" nzTheme="outline"></span>
      </button>
    </div>

  </div>

  <div style="padding: 20px">
    <nz-input-group nzPrefixIcon="search">
      <input nzAllowClear style="padding: 10px" (keyup)="search($event)" type="text" nz-input
        placeholder="Search by Name, Phone, Email or User ID" />
    </nz-input-group>
  </div>

  <div style="padding: 0 20px 20px 20px;">
    <nz-tabset nzType="card" (nzSelectedIndexChange)="onTabChange($event)">
      <nz-tab nzTitle="Active Users"></nz-tab>
      <nz-tab nzTitle="Inactive Users"></nz-tab>
    </nz-tabset>
  </div>

  <div>
    <nz-table #userTable [nzData]="usersList" [nzLoading]="spinner" nzBordered nzShowSizeChanger>
      <thead>
        <tr>
          <th>ID</th>
          <th>Name</th>
          <th>Email</th>
          <th>Phone</th>
          <th>Company</th>
          <th>Distributor</th>
          <th>Status</th>
          <th *ngIf="hasPermission('manage_users')"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let u of userTable.data">
          <td>{{ u.user_id }}</td>
          <td>{{ u.first_name | titlecase }} {{ u.last_name | titlecase }}</td>
          <td>{{ u.email }}</td>
          <td>{{ phoneNumberDisplay(u.phone?.toString()) || '' }}</td>
          <td>{{ u.company }}</td>
          <td>{{ u.distributor }}</td>
          <td>
            <nz-tag [nzColor]="u.status == 'active' ? 'green' : 'red'">
              {{ u.status | titlecase }}
            </nz-tag>
          </td>
          <td *ngIf="hasPermission('manage_users')">
            <div style="display: flex; justify-content: center; gap: 5px;">
              <button nz-button nz-popover nzPopoverContent="Edit User" nzType="primary" nzShape="circle"
                (click)="showModal(u)">
                <span nz-icon nzType="edit" nzTheme="outline"></span>
              </button>

              <button nz-button nz-popover nzPopoverContent="Impersonate User" nzType="primary" nzShape="circle"
                (click)="impersonateUser(u)">
                <span nz-icon nzType="user-switch" nzTheme="outline"></span>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>

</div>

<nz-modal [(nzVisible)]="addModal" nzTitle="User" nzCentered (nzOnCancel)="cancelModal()" (nzOnOk)="confirmModal()">
  <ng-container *nzModalContent>
    <form [formGroup]="userForm">

      <nz-form-item>
        <nz-form-label nzRequired>First Name</nz-form-label>
        <input nz-input formControlName="firstName" placeholder="John" />
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzRequired>Last Name</nz-form-label>
        <input nz-input formControlName="lastName" placeholder="Doe" />
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzRequired>Email</nz-form-label>
        <input nz-input formControlName="email" placeholder="email@email.com" />
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzRequired>Phone</nz-form-label>
        <input nz-input mask="0(000) 000-0000" placeholder="1(123) 123-1234" formControlName="phone" />
      </nz-form-item>

      <nz-form-item *ngIf="canSee">
        <nz-form-label nzRequired>Company</nz-form-label>
        <nz-select (ngModelChange)="getAssociatedCompanyInfo()" nzShowSearch nzAllowClear formControlName="company"
          nzPlaceHolder="Select company">
          <nz-option *ngFor="let c of companies" [nzValue]="c.id" [nzLabel]="c.name"></nz-option>
        </nz-select>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label>Providers</nz-form-label>
        <nz-select nzMode="multiple" nzAllowClear nzShowSearch nzPlaceHolder="Select providers (optional)"
          formControlName="providers">
          <nz-option *ngFor="let p of sort()" [nzLabel]="p.name" [nzValue]="p.id"></nz-option>
        </nz-select>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzRequired>Role</nz-form-label>
        <nz-select nzShowSearch nzAllowClear formControlName="role" nzPlaceHolder="Select users system role">
          <nz-option *ngFor="let r of roles" [nzValue]="r.id" [nzLabel]="r.name"></nz-option>
        </nz-select>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzFor="dropdownField"
          nzTooltipTitle="This field is for people having the ability to view all projects associated with this group(s). But not assigned to it."
          nzTooltipIcon="info-circle">
          Viewable Group(s)
        </nz-form-label>
        <nz-select nzMode="multiple" nzAllowClear nzShowSearch formControlName="groupsVisiblity"
          nzPlaceHolder="Select groups user has access to see (optional)">
          <nz-option *ngFor="let g of groups" [nzValue]="g.id" [nzLabel]="g.name"></nz-option>
        </nz-select>
      </nz-form-item>

      <nz-form-control>
        <nz-form-label nzFor="dropdownField" nzTooltipTitle="These are all documents that the user must sign."
          nzTooltipIcon="info-circle">
          Documents Needed
        </nz-form-label>
        <nz-select nzMode="multiple" nzAllowClear nzShowSearch formControlName="documents"
          nzPlaceHolder="Select documents the user needs to sign (optional)">
          <nz-option *ngFor="let d of all_templates" [nzValue]="d.id" [nzLabel]="d.name"></nz-option>
        </nz-select>
      </nz-form-control>

      <nz-form-item>
        <nz-form-label>Payplans</nz-form-label>
        <nz-select formControlName="payplans" nzMode="multiple" nzPlaceHolder="Select payplans">
          <nz-option *ngFor="let plan of payplans" [nzValue]="plan.id" [nzLabel]="plan.name"> </nz-option>
        </nz-select>
      </nz-form-item>

      <nz-form-control>
        <nz-form-label nzFor="dropdownField"
          nzTooltipTitle="Fidium only external values, used for mapping from fidium master" nzTooltipIcon="info-circle">
          Fidium Externals (Press Enter to Add, Then Save)
        </nz-form-label>
        <input nz-input formControlName="fidiumExternal" (keyup.enter)="addChip()"
          placeholder="Add a Fidium External" />
        <nz-tag style="margin-bottom: 5px;" *ngFor="let chip of fidiumExternals" nzMode="closeable"
          (nzOnClose)="removeChip(chip)">
          {{ chip }}
        </nz-tag>
      </nz-form-control>

      <button nz-button type="button" (click)="addProviderExternal()">
        Add Provider External
      </button>

      <div formArrayName="providerExternals" style="margin-top: 5px; margin-bottom: 5px;">

        <div *ngFor="let group of providerExternals.controls; let i = index" [formGroupName]="i">
          <nz-space style="display: flex; flex-direction: row;">

            <nz-select formControlName="key" [nzPlaceHolder]="'Select provider'">
              <nz-option *ngFor="let p of providers" [nzLabel]="p.name" [nzValue]="p.id"></nz-option>
            </nz-select>

            <input [readonly]="!group.get('key')?.value" nz-input formControlName="value" placeholder="Enter value" />

            <button nzShape="round" nz-button type="button" nzType="primary" nzDanger
              (click)="removeProviderExternal(i)">
              <span nz-icon nzType="delete" nzTheme="outline"></span>
            </button>

          </nz-space>
        </div>

      </div>

      <nz-form-item>
        <nz-form-label>Can add pins?</nz-form-label>
        <nz-form-control>
          <label nz-checkbox formControlName="pins"></label>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label>Can add areas?</nz-form-label>
        <nz-form-control>
          <label nz-checkbox formControlName="areas"></label>
        </nz-form-control>
      </nz-form-item>

    </form>

  </ng-container>
</nz-modal>
